"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionAfterViewed = ActionAfterViewed;
var React = _interopRequireWildcard(require("react"));
var _throttleDebounce = require("throttle-debounce");
var _utils = require("../../utils");
var _percentVisible = require("../../constants/percentVisible");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const THROTTLE_TIME = 100;
const DEFAULT_TIMEOUT = 0;
function ActionAfterViewed(_ref) {
  let {
    children,
    percentVisible = _percentVisible.EPercentVisible.Percent50,
    timeoutCallback = DEFAULT_TIMEOUT,
    parentBlockCssClass,
    callback
  } = _ref;
  let timer;
  const parent = {};
  const ref = React.useRef(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleScroll = React.useCallback((0, _throttleDebounce.throttle)(THROTTLE_TIME, () => {
    /* istanbul ignore else */
    if (ref.current) {
      const isVisible = parentBlockCssClass ? (0, _utils.isElementInParentBlock)(ref.current, parent.current, percentVisible) : (0, _utils.isElementInViewport)(ref.current, percentVisible);
      if (isVisible) {
        if (!timer) {
          timer = window.setTimeout(() => {
            parent.current.removeEventListener('scroll', handleScroll);
            clearTimeout(timer);
            callback();
          }, timeoutCallback);
        }
      } else if (timer) {
        clearTimeout(timer);
        timer = undefined;
      }
    }
  }), []);
  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    parent.current = (0, _utils.getValidParent)(ref.current, parentBlockCssClass);
    parent.current.addEventListener('scroll', handleScroll);
    return () => {
      parent.current.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, children);
}